import clone from 'fast-clone';

import {
  getNodeId,
  getNodeParentId,
} from '../store/actionHandlers/common/adapterActions';

export default class NodesMeta {
  constructor({ buildMeta = () => ({}) }) {
    this._buildMeta = buildMeta;
  }

  get key() {
    return 'nodesMeta';
  }

  prepareTreeState(treeState) {
    treeState.nodesMeta = {};
  }

  handleDidAddModels(treeState, models, { adapter }) {
    const nodesMeta = clone(treeState.nodesMeta);

    const queue = [...models];

    while (queue.length) {
      const model = queue.shift();
      const id = getNodeId(adapter, model);
      const parentId = getNodeParentId(adapter, model);

      if (!parentId) {
        nodesMeta[id] = this._buildMeta(model, null);
        continue;
      }

      const parentMeta = nodesMeta[parentId];
      if (!parentMeta && treeState.parents.hasOwnProperty(id)) {
        queue.push(model);
        continue;
      }

      if (treeState.context?.setMainTreeChildrenCounts) {
        treeState.context.setMainTreeChildrenCounts(
          parentId,
          ~~treeState.children[parentId]?.length,
        );
      }

      nodesMeta[id] = this._buildMeta(model, parentMeta);
    }

    treeState.nodesMeta = nodesMeta;
  }

  handleDidUpdateTree(treeState, { adapter }) {
    const { inputModels } = treeState;
    this.handleDidAddModels(treeState, inputModels, { adapter });
  }

  handleWillRemoveModels(treeState, removedIds) {
    const nodesMeta = clone(treeState.nodesMeta);

    removedIds.forEach(id => {
      const parentId = treeState.parents[id];
      const parent = treeState.models[parentId];
      const children = treeState.children[parentId];

      const parentMeta = this._buildMeta(parent, null);

      children.forEach(childrenId => {
        if (!removedIds.has(childrenId)) {
          const model = treeState.models[childrenId];
          this._buildMeta(model, parentMeta);
        }
      });

      nodesMeta[parentId] = parentMeta;
    });

    treeState.nodesMeta = nodesMeta;
  }

  handleDidRemoveModels(treeState, removedIds) {
    const nodesMeta = clone(treeState.nodesMeta);
    removedIds.forEach(id => {
      delete nodesMeta[id];
      const parentId = treeState.parents[id];
      if (parentId) {
        if (treeState.context?.setMainTreeChildrenCounts) {
          treeState.context.setMainTreeChildrenCounts(
            parentId,
            ~~treeState.children[parentId]?.length,
          );
        }
      }
    });
    treeState.nodesMeta = nodesMeta;
  }

  getNodesMeta(treeState, nodeId) {
    return treeState.nodesMeta[nodeId];
  }
}
